import {useProductOptions} from '@shopify/hydrogen';
import clsx from 'clsx';
import * as R from 'ramda';

//types
import type {ProductVariant} from '@shopify/hydrogen/storefront-api-types';
import type {Maybe, Image as ImageProps} from '@shopify/hydrogen/storefront-api-types';

interface ColourOptionsWithThumbnail {
  colour: string;
  thumbnail: Maybe<ImageProps> | undefined;
  available?: boolean;
  sizes?: {size: string | undefined; available: boolean}[];
}

export default function ProductOptionSize({
  name,
  values,
  allColourOptionsWithThumbnail,
  availableVariants,
}: {
  name: string;
  values: string[];
  allColourOptionsWithThumbnail?: ColourOptionsWithThumbnail[] | undefined;
  availableVariants: ProductVariant[];
}) {
  const {setSelectedOption, selectedOptions, options} = useProductOptions();

  const hasColourOptions = !R.isNil(options?.find((o) => o?.name === 'Colour'));

  const allColourOptionValues = R.uniq(
    availableVariants.map(
      (v) => v.selectedOptions?.find((o) => o?.name === 'Colour')?.value,
    ),
  );
  // console.log(selectedOptions);

  // console.log(allColourOptionValues)

  const selectedColour = selectedOptions?.Colour;
  const availableVariantsOfTheSelectedColour = availableVariants.filter(
    (v) =>
      v.selectedOptions?.find((o) => o?.name === 'Colour')?.value ===
      selectedColour,
  );
  const availableSizes = availableVariantsOfTheSelectedColour.map(
    (v) => v.selectedOptions.find((o) => o?.name === 'Size')?.value,
  );

  return (
    <ul className="group-hover:opacity-100 opacity-0 flex -mx-1 flex-wrap justify-center">
      {values.map((value, index) => {
        const checked = selectedOptions?.[name] === value;
        const id = `option-${name}-${value}`;
        const sizeIsAvailable = availableSizes.includes(value);
        return (
          <li
            title={value}
            key={`${id}-${index}`}
            className={clsx([
              'product-variant--size p-1',
              sizeIsAvailable ? '' : 'pointer-events-none opacity-25',
            ])}
          >
            <label key={id} htmlFor={id}>
              <div
                className={clsx([
                  'flex min-h-[18px] min-w-[18px] cursor-pointer justify-center items-center rounded-[6px] bg-black p-1 text-center text-sm leading-none text-white',
                ])}
              >
                <span className="">{value}</span>
              </div>
            </label>
          </li>
        );
      })}
    </ul>
  );
}
